<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrProses from "@/models/StrProses.js";
import StrProsesTablo from "@/models/StrProsesTablo.js";
import AddEdit from "./AddEdit.vue";
import StrProsesTabloIndex from "../StrProsesTablo/Index.vue";
import AddEditStrProsesTablo from "../StrProsesTablo/AddEdit.vue";

import { EventBus } from  "@/main";

export default {
  mixins: [Api, Sabit, StrProses,StrProsesTablo],
  page: {
    title: "Prosesler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
    StrProsesTabloIndex,
    AddEditStrProsesTablo
  },
  data() {
    return {
      title: this.$t("StrProses.Title"),
      items: [
        {
          text: this.$t("StrProses.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrProses.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrProses.Title"),
          active: true,
        },
      ],
      islem: "",
      TableData: [],
      StrPerfDonem: [],
      DataUpdate: "",
      DataUpdateAlt:"",
      Prosesid:"",
      Ustid:null,
      Seviye:1,
      AddEdit: "",
      AddEditAlt:"",
      FormTitle: "",
      FilitrelemePenceresi: false,
      Filter: {
        ProsesAdi: "",
      
      },
      siralama:"&Asc=Aciklama",

      DefaultPage: 1,

      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },

  methods: {
    Get() {
      let Filter = "";

      this.TableData=[];

      if (this.Filter.ProsesAdi!=null && this.Filter.ProsesAdi!=""){
        Filter=Filter+"&ProsesAdi="+this.Filter.ProsesAdi;
      }


      this.ActionsFilterGet({ Service: "StrProses", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    Ekleme(veri){
      this.DataUpdateAlt=this.StrProsesTabloData;
      this.Prosesid=veri[0];
      this.Seviye=veri[1];
      this.Ustid=veri[2];
      this.AddEditAlt='Add';
    },
    Duzeltme(veri){
      this.DataUpdateAlt=veri;
      this.AddEditAlt='Edit';
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  created(){
    EventBus.$on("Ekleme",(data)=>{
        console.log(data)
        this.Ekleme(data);
     });

     EventBus.$on("Duzeltme",(data)=>{
     
        this.Duzeltme(data);
     });

  }


};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input @input="Filter.ProsesAdi.length >= 3 || Filter.ProsesAdi.length == 0 ? Get() : ''" 
                    v-model="Filter.ProsesAdi" type="text" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrStratejikAmac.Page.Filtreleme") }}</button>

                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrProses @click="(DataUpdate = StrProsesData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ this.$t("StrProses.Page.YeniKayitEkle") }}</button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" style="width: 50px;"></th>
                    <th scope="col">{{ this.$t("StrProses.Table.Prosesler") }}
                      
                    <i style="margin-left:10px" v-if="siralama!='&Asc=Aciklama'" @click="siralama='&Asc=Aciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Aciklama'" @click="siralama='&Desc=Aciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    
                    <th style="width: 80px; text-align: center; vertical-align: middle;">{{ this.$t("StrProses.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="Data in TableData" >
                  <tr :key="Data.Id">
                    <th scope="row" class="custom-accordion">
                      <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" v-b-toggle="'CollapseAltTablo' + Data.Id" role="button" aria-expanded="false" aria-controls="categories-collapse">
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
                    <td>{{ Data.Prosesadi }}</td>
                    <td style="width: 80px; text-align: center; vertical-align: middle;">
                      <b-button-group>
                        <b-button variant="primary" v-b-modal.StrProsesTablo @click="(DataUpdateAlt = StrProsesTabloData), 
                          (AddEditAlt = 'Add'),(Prosesid=Data.Id),(Seviye=1)">
                            <i class="fas fa-plus"></i></b-button>
                        <b-button variant="success" v-b-modal.StrProses @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                        <b-button variant="danger" @click="Delete('StrProses', Data.Id)"><i class="fas fa-trash-alt"></i></b-button>
                      </b-button-group>
                      
                    </td>
                  </tr>
                  <tr :key="Data.Id">
                    <td></td>
                    <td colspan="2">
                          <b-collapse b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.Id">

                              <StrProsesTabloIndex 
                              :Prosesid="Data.Id"  
                              :Ustid="null" 
                              :Seviye="1"
                              />

                          </b-collapse>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>

              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"></b-pagination>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />

      <AddEditStrProsesTablo :Id="DataUpdateAlt" :AddEdit="AddEditAlt" 
      :Prosesid="Prosesid" :Ustid="Ustid" :Seviye="Seviye"  />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrProses.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrProses.Filtreleme.Content") }}
            <hr />



            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrProses.Filtreleme.ProsesAdi") }}</label>
              <b-form-input v-model="Filter.ProsesAdi" for="text" value=""></b-form-input>
            </div>

            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrProses.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
